module.exports = __webpack_public_path__ + "static/media/f508b010-28aa-44d2-9e16-77f09c5b056c.7ca73c3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/f508b010-28aa-44d2-9e16-77f09c5b056c.jpg
// module id = 865
// module chunks = 0